import { render, staticRenderFns } from "./forgetPassWord.vue?vue&type=template&id=02ea251a&scoped=true&"
import script from "./forgetPassWord.vue?vue&type=script&lang=js&"
export * from "./forgetPassWord.vue?vue&type=script&lang=js&"
import style0 from "./forgetPassWord.vue?vue&type=style&index=0&id=02ea251a&lang=less&scoped=true&"
import style1 from "./forgetPassWord.vue?vue&type=style&index=1&id=02ea251a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ea251a",
  null
  
)

export default component.exports